(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('activityResumoAfericoes', ActivityResumoAfericoes);

  function ActivityResumoAfericoes() {
    return {
      restrict: 'E',
      controller: 'ResumoAfericoesCtrl',
      templateUrl: 'views/painel_propriedade/_resumo_afericoes.html',
      scope: {
        tipo: '<',
        data: '<'
      }
    };
  }
}());
